import React, { Component } from 'react';
import {lang} from '../Core/lang';

const txtLang = lang.txt;
class FormNote extends Component {
    constructor(props){
        super(props);
        this.state = {
            message: '',
            counting: 0,
            maxLength: 1000
        };
        ['handleChangeField'].forEach(fn => this[fn] = this[fn].bind(this));
    }
    handleChangeField(e){
        let {value} = e.target;
		let infoData = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;
		if(infoData){
			infoData['message'] = value;
			localStorage.setItem('infoData', JSON.stringify(infoData));
		}else{
			localStorage.setItem('infoData',JSON.stringify({'message': value}));
		}
		this.setState({
            message: value,
            counting: value.length
		})
    }
    componentDidMount(){
        // let infoData = localStorage.getItem('infoData') ? JSON.parse(localStorage.getItem('infoData')) : null;        
		// if(infoData && infoData.message){         
        //     let messageValue = infoData.message;            
		// 	this.setState({
        //         message: messageValue,
        //         counting: messageValue.length
        //     })
		// }
    }
    render() {
        return (
            <div className="form-notes">
                <textarea 
                    value={this.state.message}
                    id="notes" 
                    cols="50" 
                    rows="5" 
                    name="message" 
                    placeholder={txtLang.notes_placeholder}
                    className="form__notes"
                    maxLength={this.state.maxLength}  onChange={e => this.handleChangeField(e)}
                />
                <span className="counting">{this.state.counting} / {this.state.maxLength}</span>
            </div>
        );
    }
}

export default FormNote;